import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Guid } from "guid-typescript";
import { map, Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { QuotationStates } from "../enums/quotation-states";
import { Quotation, QuotationDetail } from "../models/quotation";

@Injectable({
  providedIn: "root",
})
export class QuotationService {
  private quotationsUrl = "quotations";
  private baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiConfig.uri + this.quotationsUrl;
  }

  getQuotations(): Observable<Quotation[]> {
    return this.http.get<Quotation[]>(this.baseUrl + "/me").pipe(map(result => result ?? []));
  }

  getQuotationDetails(id: Guid): Observable<QuotationDetail> {
    return this.http.get<QuotationDetail>(this.baseUrl + "/" + id + "/me");
  }

  isQuotationExpiringSoon(expirationDate: Date): boolean {
    const currentDate = new Date();
    const expiration = new Date(expirationDate);
    const diffTime = Math.abs(expiration.getTime() - currentDate.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays <= 7;
  }

  getCustomStatus(quotation: Quotation | QuotationDetail): string {
    if (quotation.status === QuotationStates.Ongoing && this.isQuotationExpiringSoon(quotation.validityDate)) {
      return QuotationStates.ExpireSoon;
    }
    return quotation.status;
  }
}
